import * as types from "./types";
import INITIAL_STATE from "./init";

// style guide: avoid destructuring state

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_FEEDBACK_GROUP:
      return { ...state, group: action.payload };
    case types.SET_DATE:
      return { ...state, date: action.payload };
    case types.CACHE_FEEDBACK:
      return { ...state, cached: [...state.cached, action.payload] };
    case types.LOAD_FEEDBACKS:
      return { ...state, cached: action.payload };
    case types.REMOVE_CACHED_FEEDBACK:
      return {
        ...state,
        cached: state.cached.filter(
          f => f.created_at !== action.payload.created_at,
        ),
      };
    case types.UPDATE_PERCENT_UPLOADED:
      return {
        ...state,
        percentUploaded: action.payload,
      };
    case types.SET_FEEDBACK_STATUS:
      return {
        ...state,
        status: action.payload,
      };
    case types.SET_FEEDBACK_REVIEW:
      return {
        ...state,
        review: action.payload,
      };
    case types.SET_IS_REVIEW_RECEIVED:
      return {
        ...state,
        isReviewReceived: action.payload,
      };
    case types.SET_SELECTED_FEEDBACK_OPTIONS:
      return {
        ...state,
        selected_fb_options: action.payload,
      };
    default:
      return state;
  }
};
